export enum CustomItemType {
  System = "System",
  Facility = "Facility",
  Personal = "Personal",
}

export enum CustomEncounterType {
  All = "**",
  Shared = "*",
  Inpatient = "IP",
  Outpatient = "OP",
  Professional = "PRO",
}

export const CUSTOMIZATION_GET_FACILITIES = "CUSTOMIZATION_GET_FACILITIES";
